<template>
  <div class="row mt-3">
    <div class="m-product-card201-menus col-12 sticky-top border-bottom p-2 border shadow-sm mt-1 ">
      <div @click="selectById('#product-detail-section')" id="product-detail"
           class="product-section-panel-header px-1 d-inline-block mx-2"
           v-t="`product.single.product_detail.detail_section_title`"/>
      <div @click="selectById('#product-intro-section')" id="product-intro"
           class="product-section-panel-header px-1 d-inline-block mx-2"
           v-t="`product.single.product_detail.intro_section_title`">
      </div>
      <div @click="selectById('#product-comment-section')" id="product-comments"
           class="product-section-panel-header px-1 d-inline-block mx-2"
           v-t="`product.single.product_detail.comment_section_title`"/>
    </div>
    <div class="col-md-12 position-relative">

      <div class="col-12">
        <h5 id="product-detail-section" data-panel-parent="product-detail"
            class="product-section-panel-section"></h5>
        <h5 class="pt-5" v-t="`product.single.product_detail.detail_section`"></h5>
        <div class="">
          <SingleProductTableFeature1 :product="product"/>
        </div>
      </div>
      <div class="col-12">
        <h5 id="product-intro-section" data-panel-parent="product-intro"
            class="product-section-panel-section "></h5>
        <h5 class="pt-5" v-t="`product.single.product_detail.intro_section`"></h5>
        <div class="" v-html="product.description"></div>
      </div>
      <div class="col-12">
        <h5 id="product-comment-section" data-panel-parent="product-comments"
            class="product-section-panel-section"></h5>
        <h5 class="pt-5" v-t="`product.single.product_detail.comment_section`"></h5>
        <div class="">
          <m-comment-archive-1 commentable_type="product" :commentable_id="product.id"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleProductTableFeature1 from "./SingleProductTableFeature1.vue";
import CommentCard1 from "../../../Comment/Card/CommentCard1.vue";
import mCommentArchive1 from "../../../Comment/Archive/CommentArchive1.vue";
import ProductInfoBox from "../SingleProduct202/ProductInfoBox.vue"

export default {
  name: "SingleProductDetail1",
  components: {ProductInfoBox, CommentCard1, SingleProductTableFeature1, mCommentArchive1},
  props: {
    product: {}
  },
  methods: {
    selectById(myElement) {
      document.querySelector(myElement).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    disablePanels() {
      let panelHeader = document.querySelectorAll('.product-section-panel-header')

      panelHeader.forEach(item => {
        item.classList.remove('active')
      })

    },
    activePanels() {
      // add setTimeout to make sure items inside wrapper generate, and it is inside the page.
      setTimeout(() => {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.disablePanels()
              // active current panel
              let active_panel_header = entry.target.getAttribute('data-panel-parent')
              document.getElementById(`${active_panel_header}`).classList.add('active')
            }
          });
        });
        const panels = document.querySelectorAll(`.product-section-panel-section`);
        panels.forEach(panel => {
          observer.observe(panel);
        })
      }, 500)
    },
  },
  mounted() {
    this.activePanels()
  }
}
</script>

<style scoped>

.m-product-card201-menus {
  background-color: #FFFFFF;
}

.m-product-card201-nav-title label:hover {
  border-bottom: 1px solid var(--primary) !important;
}

.m-product-card201-menus span {
  cursor: pointer;
}

.active {
  border-bottom: 3px solid var(--primary);
  border-radius: 4px;
  padding-bottom: 2px;
  color: var(--primary);
  transition: border-bottom .3s ease !important;
}

.product-section-panel-header {
  cursor: pointer;
}
</style>